import { render } from "./InternalProductCustomFieldsPage.vue?vue&type=template&id=7ffc7062"
import script from "./InternalProductCustomFieldsPage.vue?vue&type=script&lang=js"
export * from "./InternalProductCustomFieldsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__